"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IPushPullViewPanelControl = void 0;
const tslib_1 = require("tslib");
const IPushPullRedux = tslib_1.__importStar(require("../Redux/ActionReducers/IPushPullRedux"));
const PopupRedux = tslib_1.__importStar(require("@adaptabletools/adaptable/src/Redux/ActionsReducers/PopupRedux"));
const React = tslib_1.__importStar(require("react"));
const ObjectFactory_1 = tslib_1.__importDefault(require("@adaptabletools/adaptable/src/Utilities/ObjectFactory"));
const StringExtensions_1 = require("@adaptabletools/adaptable/src/Utilities/Extensions/StringExtensions");
const rebass_1 = require("rebass");
const DropdownButton_1 = tslib_1.__importDefault(require("@adaptabletools/adaptable/src/components/DropdownButton"));
const ButtonExport_1 = require("@adaptabletools/adaptable/src/View/Components/Buttons/ButtonExport");
const ButtonPause_1 = require("@adaptabletools/adaptable/src/View/Components/Buttons/ButtonPause");
const ButtonPlay_1 = require("@adaptabletools/adaptable/src/View/Components/Buttons/ButtonPlay");
const join_1 = tslib_1.__importDefault(require("@adaptabletools/adaptable/src/components/utils/join"));
const GeneralConstants = tslib_1.__importStar(require("@adaptabletools/adaptable/src/Utilities/Constants/GeneralConstants"));
const ButtonSchedule_1 = require("@adaptabletools/adaptable/src/View/Components/Buttons/ButtonSchedule");
const ButtonNewPage_1 = require("@adaptabletools/adaptable/src/View/Components/Buttons/ButtonNewPage");
const ButtonLogout_1 = require("@adaptabletools/adaptable/src/View/Components/Buttons/ButtonLogout");
const ButtonLogin_1 = require("@adaptabletools/adaptable/src/View/Components/Buttons/ButtonLogin");
const ModuleConstants = tslib_1.__importStar(require("@adaptabletools/adaptable/src/Utilities/Constants/ModuleConstants"));
const react_redux_1 = require("react-redux");
const IPushPullViewPanelComponent = (props) => {
    var _a, _b, _c, _d;
    const [_, update] = React.useState(0);
    const forceUpdate = () => update((x) => x + 1);
    const onLiveDataChanged = React.useCallback((liveDataChangedInfo) => {
        if (liveDataChangedInfo.reportDestination == 'ipushpull' &&
            (liveDataChangedInfo.liveDataTrigger == 'Connected' ||
                liveDataChangedInfo.liveDataTrigger == 'Disconnected')) {
            forceUpdate();
        }
    }, []);
    const getIPPApi = React.useCallback(() => {
        return props.api.pluginsApi.getipushpullPluginApi();
    }, []);
    React.useEffect(() => {
        props.api.eventApi.on('LiveDataChanged', onLiveDataChanged);
        return () => {
            props.api.eventApi.off('LiveDataChanged', onLiveDataChanged);
        };
    }, []);
    const onSelectedReportChanged = (reportName) => props.onCurrentIPushPullReportNameChange(reportName);
    const onFolderChanged = (folder) => props.onCurrentIPushPullFolderChange(folder);
    const onPageChanged = (page) => props.onCurrentIPushPullPageChange(page);
    const onIPushPullSendSnapshot = () => {
        props.onIPushPullSendSnapshot(createIPushPullReportFromState());
    };
    const onIPushPullStartLiveData = () => {
        props.onIPushPullStartLiveData(createIPushPullReportFromState());
    };
    const onNewIPushPullSchedule = () => {
        let iPushPullSchedule = ObjectFactory_1.default.CreateIPushPullSchedule(createIPushPullReportFromState());
        props.onNewIPushPullSchedule(iPushPullSchedule);
    };
    // perhaps this should be props and in real state?
    const createIPushPullReportFromState = () => {
        return {
            ReportName: props.CurrentIPushPullReportName,
            Folder: props.CurrentIPushPullFolder,
            Page: props.CurrentIPushPullPage,
        };
    };
    let systemReports = getIPPApi().includeSystemReports()
        ? props.api.exportApi.getAvailableSystemReports()
        : [];
    let allReports = systemReports
        .filter((s) => props.api.internalApi.getReportService().IsSystemReportActive(s))
        .concat(props.Reports.map((r) => r.Name));
    let availableReports = allReports.map((report) => {
        return {
            label: report,
            value: report,
            onClick: () => onSelectedReportChanged(report),
        };
    });
    let availableFolders = (_b = (_a = props.IPushPullDomainsPages) === null || _a === void 0 ? void 0 : _a.map((iPushPullDomain) => {
        return {
            label: iPushPullDomain.Name,
            value: iPushPullDomain.Name,
            onClick: () => onFolderChanged(iPushPullDomain.Name),
        };
    })) !== null && _b !== void 0 ? _b : [];
    let availablePages = (_d = (_c = props.CurrentIPushPullAvailablePages) === null || _c === void 0 ? void 0 : _c.map((page) => {
        return {
            label: page,
            value: page,
            onClick: () => onPageChanged(page),
        };
    })) !== null && _d !== void 0 ? _d : [];
    // this is clearly ridiculous!
    // im getting tired...
    let isCompletedReport = StringExtensions_1.StringExtensions.IsNotNullOrEmpty(props.CurrentIPushPullReportName) &&
        StringExtensions_1.StringExtensions.IsNotNullOrEmpty(props.CurrentIPushPullFolder) &&
        StringExtensions_1.StringExtensions.IsNotNullOrEmpty(props.CurrentIPushPullPage);
    let isLiveIPushPullReport = isCompletedReport &&
        props.CurrentLiveIPushPullReport &&
        props.CurrentIPushPullReportName == props.CurrentLiveIPushPullReport.ReportName &&
        props.CurrentIPushPullFolder == props.CurrentLiveIPushPullReport.Folder &&
        props.CurrentIPushPullPage == props.CurrentLiveIPushPullReport.Page;
    const elementType = props.viewType === 'Toolbar' ? 'DashboardToolbar' : 'ToolPanel';
    return props.IsIPushPullRunning ? (React.createElement(rebass_1.Flex, { flexDirection: "row", className: `ab-${elementType}__IPushPull__wrap`, flexWrap: props.viewType === 'ToolPanel' ? 'wrap' : 'nowrap' },
        React.createElement(rebass_1.Flex, null,
            React.createElement(DropdownButton_1.default, { disabled: allReports.length == 0 || isLiveIPushPullReport, style: { minWidth: 140, fontSize: 'small' }, items: availableReports, columns: ['label'], className: `ab-${elementType}__IPushPull__select`, onClear: () => onSelectedReportChanged(''), showClearButton: StringExtensions_1.StringExtensions.IsNotNullOrEmpty(props.CurrentIPushPullReportName), variant: "outlined", marginRight: 2 }, StringExtensions_1.StringExtensions.IsNotNullOrEmpty(props.CurrentIPushPullReportName)
                ? props.CurrentIPushPullReportName
                : 'Select Report')),
        React.createElement(rebass_1.Flex, null,
            React.createElement(DropdownButton_1.default, { disabled: allReports.length == 0 || isLiveIPushPullReport, style: { minWidth: 140, fontSize: 'small' }, items: availableFolders, columns: ['label'], className: `ab-${elementType}__IPushPull__select`, onClear: () => onFolderChanged(''), showClearButton: StringExtensions_1.StringExtensions.IsNotNullOrEmpty(props.CurrentIPushPullFolder), variant: "outlined", marginRight: 2 }, StringExtensions_1.StringExtensions.IsNotNullOrEmpty(props.CurrentIPushPullFolder)
                ? props.CurrentIPushPullFolder
                : 'Select Folder')),
        React.createElement(rebass_1.Flex, null,
            React.createElement(DropdownButton_1.default, { disabled: allReports.length == 0 || isLiveIPushPullReport, style: { minWidth: 140, fontSize: 'small' }, items: availablePages, columns: ['label'], className: `ab-${elementType}__IPushPull__select`, onClear: () => onPageChanged(''), showClearButton: StringExtensions_1.StringExtensions.IsNotNullOrEmpty(props.CurrentIPushPullPage), variant: "outlined", marginRight: 2 }, StringExtensions_1.StringExtensions.IsNotNullOrEmpty(props.CurrentIPushPullPage)
                ? props.CurrentIPushPullPage
                : 'Select Page')),
        React.createElement(rebass_1.Flex, { style: { minWidth: '148px' } },
            React.createElement(ButtonExport_1.ButtonExport, { marginLeft: 1, className: `ab-${elementType}__IPushPull__export`, onClick: () => onIPushPullSendSnapshot(), tooltip: "Send Snapshot to ipushpull", disabled: isLiveIPushPullReport || !isCompletedReport, accessLevel: props.accessLevel }),
            true ? (React.createElement(ButtonPause_1.ButtonPause, { fillColor: 'red', marginLeft: 1, className: `ab-${elementType}__IPushPull__pause`, onClick: () => props.onIPushPullStopLiveData(), tooltip: "Stop sync with ipushpull", disabled: !isLiveIPushPullReport, accessLevel: props.accessLevel })) : (React.createElement(ButtonPlay_1.ButtonPlay, { marginLeft: 1, className: `ab-${elementType}__IPushPull__play`, onClick: () => onIPushPullStartLiveData(), tooltip: "Start sync with ipushpull", disabled: isLiveIPushPullReport || !isCompletedReport, accessLevel: props.accessLevel })),
            isCompletedReport && (React.createElement(rebass_1.Flex, { className: (0, join_1.default)(props.accessLevel == 'ReadOnly' ? GeneralConstants.READ_ONLY_STYLE : '', `ab-${elementType}__IPushPull__controls`), alignItems: "stretch" }, props.api.internalApi.getEntitlementService().isModuleFullEntitlement('Schedule') && (React.createElement(ButtonSchedule_1.ButtonSchedule, { marginLeft: 1, className: `ab-${elementType}__IPushPull__schedule`, onClick: () => onNewIPushPullSchedule(), tooltip: "Schedule", disabled: isLiveIPushPullReport || !isCompletedReport, accessLevel: props.accessLevel })))),
            ' ',
            React.createElement(ButtonNewPage_1.ButtonNewPage, { marginLeft: 1, className: `ab-${elementType}__IPushPull__newpage`, onClick: () => props.onShowAddIPushPullPage(), tooltip: "New Page", disabled: isLiveIPushPullReport, accessLevel: props.accessLevel }),
            React.createElement(ButtonLogout_1.ButtonLogout, { marginLeft: 1, className: `ab-${elementType}__IPushPull__logout`, onClick: () => getIPPApi().logoutFromIPushPull(), tooltip: "Logout", disabled: isLiveIPushPullReport, accessLevel: props.accessLevel })))) : (React.createElement(ButtonLogin_1.ButtonLogin, { marginLeft: 1, className: `ab-${elementType}__IPushPull__login`, onClick: () => props.onShowIPushPullLogin(), tooltip: "Login to ipushpull", accessLevel: props.accessLevel },
        ' ',
        "Login"));
};
function mapStateToProps(state) {
    return {
        CurrentLiveIPushPullReport: state.System.CurrentLiveIPushPullReport,
        Reports: state.Export.Reports,
        IPushPullDomainsPages: state.System.IPushPullDomainsPages,
        IsIPushPullRunning: state.System.IsIPushPullRunning,
        CurrentIPushPullReportName: state.System.IPushPullCurrentReportName,
        CurrentIPushPullFolder: state.System.IPushPullCurrentFolder,
        CurrentIPushPullPage: state.System.IPushPullCurrentPage,
        CurrentIPushPullAvailablePages: state.System.IPushPullCurrentAvailablePages,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        onIPushPullSendSnapshot: (iPushPullReport) => dispatch(IPushPullRedux.IPushPullSendSnapshot(iPushPullReport)),
        onIPushPullStartLiveData: (iPushPullReport) => dispatch(IPushPullRedux.IPushPullStartLiveData(iPushPullReport)),
        onIPushPullStopLiveData: () => dispatch(IPushPullRedux.IPushPullStopLiveData()),
        onNewIPushPullSchedule: (iPushPullSchedule) => dispatch(PopupRedux.PopupShowScreen(ModuleConstants.ScheduleModuleId, 'SchedulePopup', {
            action: 'New',
            source: 'Toolbar',
            value: iPushPullSchedule,
        })),
        onShowIPushPullLogin: () => dispatch(PopupRedux.PopupShowScreen(ModuleConstants.IPushPullModuleId, 'IPushPullLoginPopup', undefined, {
            footer: false,
        })),
        onShowAddIPushPullPage: () => dispatch(PopupRedux.PopupShowScreen(ModuleConstants.IPushPullModuleId, 'IPushPullAddPagePopup', undefined, {
            footer: false,
        })),
        onCurrentIPushPullReportNameChange: (reportName) => dispatch(IPushPullRedux.IPushPullSetCurrentReportName(reportName)),
        onCurrentIPushPullFolderChange: (folder) => dispatch(IPushPullRedux.IPushPullSetCurrentFolder(folder)),
        onCurrentIPushPullPageChange: (page) => dispatch(IPushPullRedux.IPushPullSetCurrentPage(page)),
    };
}
exports.IPushPullViewPanelControl = (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps)(IPushPullViewPanelComponent);
